/* eslint-disable import/order */
import {
  SmartAccountHeadingText,
  greyColor,
  maxTablet, maxWidth, midTablet,
  primaryColor, primaryFont, retina, scrollbar,
  smMobile,
  wMBold,
  wMedium,
} from 'Utils/utilsStyle';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import CompaniesCheckIcon from '../svgIcons/CompaniesCheckIcon';
import SmartAccountCompanies from './SmartAccountCompanies';
import { AetnaHierarchyCompanyCard } from 'Types/CompaniesTypes';
import SmartPlanSliderFooter from './SmartPlanSliderFooter';


const Wrapper = styled.div`
  &.historyTab {
    height: calc(100% - 0px);
    overflow: hidden;
  }
  display: absolute;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 70px);
  ${scrollbar};
  border-radius: 0 !important;
  @media all and (max-height: ${midTablet}) {
    height: calc(100% - 31px);
  }
  @media all and (max-width: ${maxTablet}) and (max-height: ${midTablet}) {
    height: calc(100% - 43px);;
  }
  .splash-header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #DEF6E6;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.12);
    padding: 47px 40px 16px;
    @media all and (max-height: ${midTablet}) {
      padding: 16px 40px 16px;
    }
    @media all and (max-width: ${smMobile}) {
      padding: 12px 20px 6px;
    }

    .smart-plan-svg{
      width: 46px;
      height: 40px;
      min-height: 40px;
      margin-bottom: 4px;
    }
    .heading-splash {
      ${SmartAccountHeadingText};
      text-align: center;
      leading-trim: both;
      text-edge: cap;
      margin-bottom: 5px;
      line-height: normal;
      @media all and (max-width: ${midTablet}) {
        font-size: 24px;
      }
      @media all and (max-width:${maxWidth}), ${retina} {
        font-size: 28px;
        line-height: 20px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 24px;
      }
      
      sup {
        font-size: 15px;
        top: -13px;
        @media all and (max-width: ${midTablet}) {
          font-size: 11px;
          top: -10px;
        }
      }
    }
    .sub-heading {
      display: flex;
      align-items: center;
      gap: 8px;
      color: ${primaryColor};
      font-family: ${primaryFont};
      font-size: 22px;
      font-style: normal;
      font-weight: ${wMBold};
      line-height: 14px; /* 63.636% */
      letter-spacing: -0.562px;
      margin-top: 16px;
      margin-bottom: 12px;
      @media all and (max-width: ${midTablet}) {
        font-size: 16px;
      }
      @media all and (max-width:${maxWidth}), ${retina} {
         font-size: 20px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 18px;  
      }
      
    }
    .description-splash {
      font-size: 16px;
      line-height: normal;
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      color: ${greyColor};
      text-align: left;
      letter-spacing: -0.562px;
      max-width: 270px;
      @media all and (max-width: ${midTablet}) {
        font-size: 13px;
      }
      @media all and (max-width:${maxWidth}), ${retina} {
        font-size: 16px;
      }
      @media all and (max-width: ${maxTablet}) {
        font-size: 14px;  
      }
    }
  }
  .tabs-div {
    display: flex;
    width: calc(100% - 24px);
    border-radius: 6.019px;
    background: #DEF6E6;
    padding: 4px 5px;
    height: 40px;
    margin: 8px 12px;
    @media all and (max-height: ${midTablet}) {
      height: 36px;
      margin-bottom: 0px;
    }
    .gilroy-custom-tab {
      &.notActive { 
        .add-icon-svg {
          rect {
            fill: #DEF6E6;
          }
        }
      }
      font-size: 14px;
      @media all and (max-width: ${maxTablet}) {
        border-radius: 4px;
        font-size: 12px;
        line-height: 14px;
      }
      .podcast-generate-tab-icon {
        @media all and (max-width: ${maxTablet}) {
          width: 13px;
          height: 11px;
        }
      }
      .add-icon-svg {
        margin-right: 7px;
        width: 18px;
        height: 18px;
        @media all and (max-width: ${maxTablet}) {
          width: 13px;
          height: 11px;
          margin-right: 5px;
        }
      }
      .history-icon {
        margin-right: 7px;
        width: 13px;
        height: 15px;
        @media all and (max-width: ${maxTablet}) {
          width: 9px;
          height: 10px;
          margin-right: 5px;
        }
      }
    }
  }
  .overlayForDrawerOnly{
    background-color: rgba(0,0,0,0.5);
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    outline: 0;
    z-index: 1000;
  }
  .smart-account-footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    border-top: 1px solid #DADADA;
  }
`;

type Props = {
  setShowAccountPlanForm: (val: boolean) => void
  companyId: number
  defaultSelectedCompanyId: number
  setMappedCompanyId: (val: number) => void
  companiesData?: AetnaHierarchyCompanyCard[]
  onCloseAetnaScreen: () => void
  showBackButton?: boolean
  onBack?: () => void
};

const SmartAccountAetnaSelection = function SmartAccountSplashScreen(props: Props) {
  const {
    companyId,
    defaultSelectedCompanyId,
    setMappedCompanyId,
    setShowAccountPlanForm,
    companiesData,
    onCloseAetnaScreen,
    showBackButton,
    onBack,
  } = props;
  const heading = 'Smart Account Plan';
  const subheading = 'Select Company';
  const description = 'Choose the company you’d like to map the Smart Account Plan with';
  const [selectedCompanyId, setSelectedCompanyId] = useState<number>(defaultSelectedCompanyId || companyId);

  const handleSelectCompany = (id: number) => {
    setSelectedCompanyId(id);
  };

  const onNextClick = () => {
    setMappedCompanyId(selectedCompanyId);
    setShowAccountPlanForm(false);
    onCloseAetnaScreen();
  };

  return (
    <Wrapper>
      <div className="splash-header">
        <h6 className="heading-splash">
          {heading}
          <sup>TM</sup>
        </h6>
        <div className='sub-heading'>
          <CompaniesCheckIcon />
          {subheading}
        </div>
        <div className="description-splash">{description}</div>
      </div>
      <SmartAccountCompanies
        companiesData={companiesData ?? []}
        selectedCompanyId={selectedCompanyId}
        onSelectCompany={handleSelectCompany}
      />
      <SmartPlanSliderFooter
        isNextDisable={false}
        isBackDisable={!showBackButton}
        showBackButton={showBackButton}
        nextBtnText="Proceed"
        onBack={() => { if (showBackButton && onBack) onBack(); }}
        onNext={onNextClick}
        highlightedComponent={false}
        showSelectedDocs={false}
      />
    </Wrapper>
  );
};

export default SmartAccountAetnaSelection;